import React from "react";
import { Link, useLocation, matchPath } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  title: string;
  trail?: BreadcrumbItem[];
  isMobile?: boolean;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  title,
  trail = [],
  isMobile = false,
}) => {
  // On mobile, we'll show just the title and a simplified trail
  return (
    <nav
      className={`flex ${
        isMobile ? "flex-col sm:flex-row sm:items-center" : "items-center"
      } ${
        isMobile ? "space-y-1 sm:space-y-0 sm:space-x-2" : "space-x-2"
      } text-sm ${isMobile ? "pb-2 sm:pb-8" : "pb-8"}`}
      aria-label="Breadcrumb"
    >
      {/* Title - larger on desktop, standard on mobile */}
      <span
        className={`font-semibold ${
          isMobile ? "text-xl sm:text-lg" : "text-lg"
        } text-gray-900 dark:text-gray-100 ${
          isMobile ? "mb-1 sm:mb-0 sm:mr-2" : "mr-2"
        }`}
      >
        {title}
      </span>

      {/* Only show trail on non-smallest screens */}
      <div
        className={`${
          isMobile ? "hidden sm:flex sm:items-center" : "flex items-center"
        }`}
      >
        {trail.length > 0 && <span className="mx-2 text-gray-400">/</span>}
        {trail.map((item, idx) => (
          <span key={idx} className="flex items-center">
            {item.to ? (
              <Link
                to={item.to}
                className="text-indigo-600 hover:underline dark:text-indigo-400"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-gray-500 dark:text-gray-400">
                {item.label}
              </span>
            )}
            {idx < trail.length - 1 && (
              <span className="mx-2 text-gray-400">/</span>
            )}
          </span>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumb;
